import axios from "axios";

const apiurl = process.env.REACT_APP_API_URL;

export const GetAndCreateProductLists = async(method,data)=>{
    return axios({
        method:method,                                         // This is used to get and post Add Products data from API
        url:`${apiurl}LADProducts/add-products/`,
        data:data
    })
}

export const GetSingleProduct = async(method,id,data)=>{
    return axios({
        method:method,                                         // This is used to get and post Add Products data from API
        url:`${apiurl}LADProducts/add-products/${id}/`,
        data:data
    })
}

export const UpdateAndDeleteProduct = async(method,id,data)=>{
    return axios({
        method:method,                                         // This is used to get and post Add Products data from API
        url:`${apiurl}LADProducts/add-products/${id}/`,
        data:data
    })
}

export const ImportAllProducts = async (method, data) => {
    return axios({
        method: method,
        url: `${apiurl}LADProducts/import-productslist/`,       // This is used to Import (upload) Unit data  and Link HSN Unit from API
        data: data
    });
}

export const ExporAllProducts = async (method, data, config = {}) => {
    return axios({
        method: method,                         
        url: `${apiurl}LADProducts/export-productslist/`,      // This is used Export (download) Unit data and Link HSN Unit from API
        data: data,
        responseType: 'blob',
        ...config
    });
};

export const ExporAllTrendingProducts = async (method, data, config = {}) => {
    return axios({
        method: method,                         
        url: `${apiurl}LADProducts/export-trending-products/`,      // This is used Export (download) all trending products list from API
        data: data,
        responseType: 'blob',
        ...config
    });
};

export const ExporAllRfq = async (method, data, config = {}) => {
    return axios({
        method: method,                         
        url: `${apiurl}LADProducts/rfq/export-all/`,      // This is used Export (download) all trending products list from API
        data: data,
        responseType: 'blob',
        ...config
    });
};

export const BulkStatusUpdate = async(method,data)=>{
    return axios({
        method:method,                                         // This is used to POST Add Products Bulk Status Update from API
        url:`${apiurl}LADProducts/bulk-update-product-status/`,
        data:data
    })
}

export const BulkEdit = async(method,data)=>{
    return axios({
        method:method,                                         // This is used to PATCH Add Products Bulk Data Edit Update from API
        url:`${apiurl}LADProducts/products/bulk-update/`,
        data:data
    })
}

export const BulkMoveToTrending = async(method,data)=>{
    return axios({
        method:method,                                        // This is used to POST Add Products Bulk Data Move To Trending Update from API
        url:`${apiurl}LADProducts/products/move-to-trending/`,
        data:data
    })
}

export const BulkRemoveFromTrending = async(method,data)=>{
    return axios({
        method:method,                                        // This is used to POST Add Products Bulk Data Remove From Trending Update from API
        url:`${apiurl}LADProducts/products/remove-from-trending/`,
        data:data
    })
}

export const BulkDelete = async(method,data)=>{
    return axios({
        method:method,                                        // This is used to POST Add Products Bulk Data Delete from API
        url:`${apiurl}LADProducts/products/bulk-delete/`,
        data:data
    })
}

export const ExportSelectedColumns = async (method, data, config = {}) => {
    return axios({
        method: method,                         
        url: `${apiurl}LADProducts/select-export-product/`,      // This is used Export (download) Unit data and Link HSN Unit from API
        data: data,
        responseType: 'blob',
        ...config
    });
};

export const ExportRfqSelectedColumns = async (method, data, config = {}) => {
    return axios({
        method: method,                         
        url: `${apiurl}LADProducts/select-export-product/`,      // This is used Export (download) Unit data and Link HSN Unit from API
        data: data,
        responseType: 'blob',
        ...config
    });
};

export const BulkAddTags = async(method,data)=>{
    return axios({
        method:method,                                        // This is used to POST Add Products Bulk Data Move To Trending Update from API
        url:`${apiurl}LADProducts/bulk-add-tags/`,
        data:data
    })
}

export const BulkAssignedto = async(method,data)=>{
    return axios({
        method:method,                                        // This is used to POST Add Products Bulk Data Move To Trending Update from API
        url:`${apiurl}LADProducts/select-bulk-product-assignment/`,
        data:data
    })
}

export const AllProductsPagination = async (method, options = {}) => {
  return axios({
    method,
    url: `${apiurl}LADProducts/add-products/`,
    ...(method === "GET" ? { params: options.params } : { data: options.data }),
  });
};

export const AllRfqPagination = async (method, options = {}) => {
  return axios({
    method,
    url: `${apiurl}LADProducts/add-products/`,
    ...(method === "GET" ? { params: options.params } : { data: options.data }),
  });
};

export const AllProductsFilter = async (method, options = {}) => {
  return axios({
    method,
    url: `${apiurl}LADProducts/products/filtersearch/`,
    ...(method === "GET" ? { params: options.params } : { data: options.data }),
  });
};

export const AllTrendingProductsFilter = async (method, options = {}) => {
  return axios({
    method,
    url: `${apiurl}LADProducts/select-filter-trending-product/`,
    ...(method === "GET" ? { params: options.params } : { data: options.data }),
  });
};

export const AllTrendingProductsPagination = async (method, options = {}) => {
  return axios({
    method,
    url: `${apiurl}LADProducts/products/trending/`,
    ...(method === "GET" ? { params: options.params } : { data: options.data }),
  });
};

export const AddGroupBy = async (method, options = {}) => {
  return axios({
    method,
    url: `${apiurl}LADProducts/group-by/`,
    ...(method === "GET" ? { params: options.params } : { data: options.data }),
  });
};

export const TrendingAddGroupBy = async (method, options = {}) => {
  return axios({
    method,
    url: `${apiurl}LADProducts/select-trending-product-groupby/`,
    ...(method === "GET" ? { params: options.params } : { data: options.data }),
  });
};

export const AscendingOrder = async (method, options = {}) => {
  return axios({
    method,
    url: `${apiurl}LADProducts/products/search/`,
    ...(method === "GET" ? { params: options.params } : { data: options.data }),
  });
};

export const DecendingOrder = async (method, options = {}) => {
  return axios({
    method,
    url: `${apiurl}LADProducts/products/search/`,
    ...(method === "GET" ? { params: options.params } : { data: options.data }),
  });
};

export const GetAndCreateTrendingProducts = async(method,data)=>{
    return axios({
        method:method,                                        // This is used to POST Add Products Bulk Data Move To Trending Update from API
        url:`${apiurl}LADProducts/products/trending/`,
        data:data
    })
}

export const GetAndCreateRfq = async(method,data)=>{
  return axios({
      method:method,                                        // This is used to POST Add Products Bulk Data Move To Trending Update from API
      url:`${apiurl}LADProducts/rfq/`,
      data:data
  })
}

export const GetSpecificRfq = async(method,id,data)=>{
  return axios({
      method:method,                                        // This is used to POST Add Products Bulk Data Move To Trending Update from API
      url:`${apiurl}LADProducts/rfq/${id}/`,
      data:data
  })
}

export const UpdateAndDeleteRfq = async(method,id,data)=>{
  return axios({
      method:method,                                         // This is used to get and post Add Products data from API
      url:`${apiurl}LADProducts/rfq/${id}/`,
      data:data
  })
}

export const GetDefaultUnitId = async(method,data)=>{
  return axios({
      method:method,                                        // This is used to POST Add Products Bulk Data Move To Trending Update from API
      url:`${apiurl}LADProducts/add-unit-products/`,
      data:data
  })
}

export const CountryAPI = async(method,data)=>{
  return axios({
      method:method,                                        // This is used to POST Add Products Bulk Data Move To Trending Update from API
      url:`${apiurl}/api/countries/`,
      data:data
  })
}

